import siteApi from "@/api/site";
import { MAP_ACTION, PERMISSION_ROLE } from "@/utils/constant";
import columnApi from "@/api/column";
import { deepQueryTree, handleTree } from "@/utils/common";

const state = {
  // 是否已经获取过对应的 可见栏目
  role: new Map(),
  // 所有的可见栏目
  menus: [],
  // 所有的menu, 不区分 是否显示, list
  allMenusList: [],
  // 所有的menu 树
  allMenusTree: [],
  // 站点信息
  siteInfo: {},
  // 当前选中的菜单
  activeMenu: {},
  // 当前选中的节点树
  activeMenuTree: [],
  // 当前选中的节点子节点(如果当前节点已经是叶子节点,则会将同一父级下的所有子节点放置在当前节点中)
  activeMenuChildren: [],
  // 当前详情的标题
  curDetailTitle: ""
};

const mutations = {
  SET_ROLE: (state, { action, role }) => {
    state.role[action](role, role);
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus || [];
  },
  SET_ALL_MENUS_LIST: (state, menus) => {
    state.allMenusList = menus || [];
  },
  SET_ALL_MENUS_TREE: (state, menus) => {
    state.allMenusTree = menus || [];
  },
  SET_SITE_INFO: (state, info) => {
    state.siteInfo = info || {};
  },
  SET_ACTIVE_MENU: (state, activeMenu) => {
    state.activeMenu = activeMenu || {};
  },
  SET_ACTIVE_MENU_TREE: (state, activeMenuTree) => {
    state.activeMenuTree = activeMenuTree || [];
  },
  SET_ACTIVE_MENU_CHILD: (state, activeMenuChildren) => {
    state.activeMenuChildren = activeMenuChildren || [];
  },
  SET_DETAIL_TITLE: (state, title) => {
    state.curDetailTitle = title;
  }
};

const actions = {
  // 获取栏目树
  getMenuList({ commit }) {
    return new Promise((resolve) => {
      columnApi
        .menuTree()
        .then((resp) => {
          commit("SET_ROLE", {
            action: MAP_ACTION.SET,
            role: PERMISSION_ROLE.MENU
          });
          commit("SET_MENUS", resp.data);
          resolve(resp.data);
        })
        .catch(() => {
          commit("SET_ROLE", {
            action: MAP_ACTION.DEL,
            role: PERMISSION_ROLE.MENU
          });
          commit("SET_MENUS", []);
        });
    });
  },
  getMenuListAll({ commit }) {
    return new Promise((resolve) => {
      columnApi.list().then((resp) => {
        commit("SET_ALL_MENUS_LIST", resp.data);
        commit("SET_ALL_MENUS_TREE", handleTree(resp.data));
        resolve(resp.data);
      });
    });
  },
  // 获取站点信息
  getSiteInfo({ commit }) {
    return new Promise((resolve) => {
      siteApi
        .getNewest()
        .then((resp) => {
          commit("SET_ROLE", {
            action: MAP_ACTION.SET,
            role: PERMISSION_ROLE.SITE
          });
          commit("SET_SITE_INFO", resp.data);
          resolve(resp.data);
        })
        .catch(() => {
          commit("SET_ROLE", {
            action: MAP_ACTION.DEL,
            role: PERMISSION_ROLE.SITE
          });
          commit("SET_SITE_INFO", []);
        });
    });
  },
  changeActiveMenu({ commit, state }, menu) {
    commit("SET_ACTIVE_MENU", menu);
  },
  getActiveMenu({ commit, state }, route) {
    const {
      params: { code },
      path,
      fullPath
    } = route;
    const menuByCode = state.allMenusList.filter(
      (item) => item.code === code
    )[0];
    const menuByPath = state.allMenusList.filter((item) => item.path === path)[0] || {};
    const menuByFullPath = state.allMenusList.filter((item) => item.path === fullPath)[0] || {};
    const menu = Object.assign({}, menuByCode, menuByPath, menuByFullPath);
    commit("SET_ACTIVE_MENU", menu);
    const activeMenuTree = deepQueryTree(state.allMenusTree, menu.id);
    commit("SET_ACTIVE_MENU_TREE", activeMenuTree);
    const activeMenuChildren =
            activeMenuTree.find((item) => item.id === menu.parentId || !menu.parentId)
              ?.children || [];
    let filteredMenuChildren = []
    if (activeMenuChildren.length > 0) {
      filteredMenuChildren = activeMenuChildren.filter(item => item.visible);
    }
    if (!filteredMenuChildren || filteredMenuChildren.length === 0) {
      filteredMenuChildren.push(menu);
    }
    commit("SET_ACTIVE_MENU_CHILD", filteredMenuChildren);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
